export const defaultProps = {
    placeholder: "XXXX"
};
